import { all } from 'core/middlewares/utilities';

import { orchestrator } from './orchestrator';
import { bff } from './services';

/**
 * Root Middleware for Side-Effects Handling
 *
 */
export function* rootEffects() {
  yield all([
    ...bff.actions.map(([action, sagaEffect]) => sagaEffect(action, bff.effects)),
    ...orchestrator.actions.map(([action, workflow, sagaEffect]) => sagaEffect(action, workflow)),
  ]);
}
